
import validator from 'validator';

const validateUpdateNotice = (data) => {
    let errors = {};

    const { title,description} = data;

    if (validator.isEmpty(title)) {
        errors.title = '제목은 필수 항목입니다.';
    }
    
    if (validator.isEmpty(description)) {
        errors.description = '설명은 필수 항목입니다.';
    }
    // if (!created_date) {
    //     errors.created_date = '날짜는 필수 항목입니다.';
    // }
    return {
        isInvalid: Object.keys(errors).length > 0,
        error: errors,
    };
};

export default validateUpdateNotice;
